// The cart the agent is working on right now. Shown in the top bar, used for prices and "in cart" marks.
// Its id survives reloads (localStorage), so the agent can browse and come back to the same customer.
import { writable, get } from 'svelte/store';
import fetchData from '../api.js';
import UserStore from './user';

const KEY = 'agents_active_cart_id';

function readId() {
	try { return localStorage.getItem(KEY) || null; } catch (e) { return null; }
}

export const activeCartId = writable(readId());
export const activeCart = writable(null);

activeCartId.subscribe((id) => {
	try {
		if (id) localStorage.setItem(KEY, id);
		else localStorage.removeItem(KEY);
	} catch (e) {
		// private mode: keep it in memory only
	}
});

export async function loadActiveCart() {
	const id = get(activeCartId);
	if (!id) {
		activeCart.set(null);
		return null;
	}
	const res = await fetchData({ action: 'agents_get_cart', token: get(UserStore).data, cart_id: id });
	const cart = res && res.data;
	// deleted, or already sent as an order: nothing to work on anymore
	if (!cart || !cart.id || cart.order_number) {
		clearActiveCart();
		return null;
	}
	activeCart.set(cart);
	return cart;
}

export function setActiveCart(id) {
	activeCartId.set(id ? String(id) : null);
	return loadActiveCart();
}

export function clearActiveCart() {
	activeCartId.set(null);
	activeCart.set(null);
}
